import type {ScreenSize} from '@cohort/wallet/components/contexts/ScreenSizeContext';
import ScreenSizeContext from '@cohort/wallet/components/contexts/ScreenSizeContext';
import {Fragment, useEffect, useState} from 'react';

const useScreenSize = (): ScreenSize | undefined => {
  const [size, setSize] = useState<ScreenSize | undefined>(undefined);

  useEffect(() => {
    const handleResize = (): void => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < 768,
      });
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return size;
};

const ScreenSizeContextProvider = ({children}: {children: React.ReactNode}): JSX.Element => {
  const screenSize = useScreenSize();
  if (screenSize === undefined) {
    return <Fragment />;
  }
  return <ScreenSizeContext.Provider value={screenSize}>{children}</ScreenSizeContext.Provider>;
};

export default ScreenSizeContextProvider;
